import React from 'react';
export function About() {
  return <section className="py-20 bg-gray-50 overflow-hidden" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-3">
          {/* Image Side */}
          <div className="w-full lg:w-1/2 relative" data-id="element-4">
            <div className="relative aspect-[3/4] max-w-md mx-auto lg:mx-0" data-id="element-5">
              {/* Decorative background element */}
              <div className="absolute -top-4 -left-4 w-full h-full border-2 border-[#D4A574] rounded-sm z-0" data-id="element-6" />

              <img src="https://cdn.magicpatterns.com/uploads/aNLq6DRhkqBSu38eMJFcU5/pasted-image.jpg" alt="Julia Pfeifer - Fotografin" className="relative z-10 w-full h-full object-cover rounded-sm shadow-xl" data-id="element-7" />
            </div>
          </div>

          {/* Text Side */}
          <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-8">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-9">
              Über mich
            </h2>
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-10">
              <p data-id="element-11">
                Ich bin{' '}
                <span className="font-semibold text-gray-900" data-id="element-12">
                  Julia Pfeifer
                </span>{' '}
                – Business- & Personal-Branding-Fotografin mit über 13 Jahren
                Erfahrung.
              </p>
              <p data-id="element-13">
                Ich helfe Unternehmer:innen, Selbständigen und Führungskräften,
                sich mit professionellen Bildern authentisch zu zeigen und genau
                die Kunden zu gewinnen, die zu ihnen passen.
              </p>
              <p data-id="element-14">
                Meine Spezialität: Ich fange nicht nur Ihr Gesicht ein, sondern
                Ihre Geschichte, Ihre Werte und das, was Sie einzigartig macht.
                In einer entspannten Atmosphäre entstehen Bilder, auf denen Sie
                sich nicht nur wohlfühlen, sondern die auch Ihre Kompetenz
                ausstrahlen.
              </p>

              <div className="pt-4" data-id="element-15">
                <img src="https://upload.wikimedia.org/wikipedia/commons/e/e4/Signature_sample.svg" alt="Unterschrift" className="h-12 opacity-60 mx-auto lg:mx-0" data-id="element-16" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}